import { Alert, Divider, Grid, Link, Stack, Typography } from "@mui/material";
import { useParams } from "react-router-dom";
import useReservationStore from "../../../stores/useReservationStore";
import ReservationForm from "../../../components/form/reservation/ReservationForm";
import PageLoading from "../../../components/layout/PageLoading";
import OrderSummary from "../../../components/displays/orders/OrderSummary";
import useCustomerStore from "../../../stores/useCustomerStore";
import CustomerForm from "../../../components/form/customer/CustomerForm";
import OrderLocationForm from "../../../components/form/orders/OrderLocationForm";
import useOrderStore from "../../../stores/useOrderStore";
import { useEffect } from "react";
import index from "../../../api/auth/reservations";

export default function Reservation() {
  const { id } = useParams();

  const { reservationById, updateReservation, reservations, setReservations } = useReservationStore();
  const { customerById } = useCustomerStore();
  const { orderById } = useOrderStore();

  const reservation = reservationById(id);
  const customer = customerById(reservation?.order?.customer_id);
  const order = orderById(reservation?.order_id);

  useEffect(() => {
    if(!reservations.length) {
      index({
        status: ['confirmed', 'paid'],
        sortBy: 'start_at',
      }, (response) => {
        setReservations(response);
      });
    }
  }, []);

  if(!reservation) return <PageLoading />;

  return (
    <Stack>
      <Stack>
        <Typography variant="h4">Reservation #{id}</Typography>
      </Stack>
      {reservation.order.status === 'paid' && <Stack mt={1}>
        <Alert severity="info">
          <Typography variant="body1">
            Updating this reservation will NOT charge or refund the customer since they have already paid for this <Link href={`/orders/${reservation.order_id}`}><b>order</b></Link>.
          </Typography>
        </Alert>
      </Stack>}
      <Stack my={2}>
        <Divider />
      </Stack>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={8}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Stack mb={1}>
                <Typography variant="h5">Customer</Typography>
              </Stack>
              <CustomerForm customer={customer} />
            </Grid>
            <Grid item xs={6}>
              <Stack mb={1}>
                <Typography variant="h5">Delivery Address</Typography>
              </Stack>
              <OrderLocationForm order={order} />
            </Grid>
          </Grid>
          <ReservationForm reservation={reservation} afterSubmit={updateReservation} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <OrderSummary order={reservation.order} />
        </Grid>
      </Grid>
    </Stack>
  );
}